export default [
    {
        "id": "blog-post",
        "plugin": "blog",
        "pluginId": 12,
        "name": "blog",
        "html": require('./blog-post/html').default,
        "js": require('./blog-post/js').default,
        "minJs": require('./blog-post/minJs').default,
        "css": require('./blog-post/css').default,
        "cssTablet": require('./blog-post/cssTablet').default,
        "cssMobile": require('./blog-post/cssMobile').default,
        "scss": require('./blog-post/scss').default,
        "scssTablet": require('./blog-post/scssTablet').default,
        "scssMobile": require('./blog-post/scssMobile').default
    }
]